import styled from 'styled-components'
import ClockIcon from '../../../images/icons/clock.svg'
import Copy from '../../../images/icons/copy.svg'
import {Product, ProductType} from 'types/rest'
import {formatDuration} from '../../../helpers/formatDuration'
import React, {PropsWithChildren, useEffect, useState} from 'react'
import {getLanguage, getTranslation, getUser} from '@store/selectors'
import {useSelector} from 'react-redux'
import useMediaQuery from '../../../hooks/useMediaQuery'
import {small} from '../../../constants'
import {BigButton} from '@components/common'
import {useLocation, useNavigate} from 'react-router-dom'
import {getProductPrice} from '../../../helpers/getProductPrice'

const InfoMasterclass: React.FC<PropsWithChildren<Props>> = ({
                                                               data,
                                                               detail = false,
                                                               courseType,
                                                               children,
                                                               jumboContainerHeight
                                                             }) => {
  const translation = useSelector(getTranslation)
  const language = useSelector(getLanguage)
  const user = useSelector(getUser)
  const isMobile = useMediaQuery(`(max-width: ${small})`)

  const navigate = useNavigate()
  const location = useLocation()

  // determina se il bottone "acquista" sticky si colora quando si scrolla in basso
  const [highlightButton, setHighlightButton] = useState(false)
  const [canWatch, setCanWatch] = useState<boolean>(false)

 /* const infoLabel = useMemo(() => {
    if (isMobile) {
      return translation.PAGES?.courses.info
    }
    switch (courseType) {
      case 'masterclass':
      case 'lesson':
        return translation.PAGES?.courses.infoLesson
      case 'podcast':
        return translation.PAGES?.courses.infoPodcast
      default:
        return translation.PAGES?.courses.infoCourse
    }
  }, [isMobile, translation.PAGES?.courses, courseType])*/

  // Listener sullo scroll della pagina per colorare il bottone acquista
  useEffect(() => {
    const handler = () => {
      if (!jumboContainerHeight) return
      if (window.scrollY >= jumboContainerHeight + 100) setHighlightButton(true)
      else setHighlightButton(false)
    }
    window.addEventListener('scroll', handler)
    return () => window.removeEventListener('scroll', handler)
  }, [jumboContainerHeight])

  // Per stabilire se chi naviga può vedere il video
  useEffect(()=>{
    if(data?.purchased || ((data.type as ProductType)?.label === 'masterclass' && user && user.verified)){
      setCanWatch(true)
      return
    }
    setCanWatch(false)
  },[data,user])

  return (
    data && (
      <Container isMobile={isMobile}>
        <InfoContainer isMobile={isMobile}>
          <InfoTextContainer canWatch={canWatch}>
            <InfoUpContainer>
              <Info>
                <div>
                  <p style={{fontSize: 'var(--surtitle-item)', margin: '0'}}>
                    {data.translations && data.translations[language].surtitle}
                  </p>
                  <p style={{fontSize: 'var(--title-h2)', fontWeight: 'bold', margin: '0' , marginBottom: '8px' }}>
                    {data.translations && data.translations[language].title}
                  </p>
                  <p style={{fontSize: 'var(--surtitle-item)', margin: '0'}}>
                    {data.translations && data.translations[language].subtitle}
                  </p>
                </div>
              </Info>
              <InfoR>
                {data && (
                  <FastInfo>
                    <img src={ClockIcon} style={{marginRight: '10px'}} alt=""/>
                    {`${formatDuration(data?.duration)}`}
                  </FastInfo>
                )}
                {courseType !== 'masterclass' && detail && data && 'productItems' in data && (
                  <FastInfo>
                    <img src={Copy} style={{marginRight: '10px'}} alt=""/>
                    {data?.productItems?.length}
                  </FastInfo>
                )}
              </InfoR>
            </InfoUpContainer>
            <Description>
              <div style={{fontSize: 'var(--big-parag-fs)', lineHeight: '1.4', whiteSpace: 'pre-wrap'}}>
                {data.translations && data.translations[language].description}
              </div>
            </Description>
          </InfoTextContainer>
          {!data?.purchased && <ButtonContainer mustVisible={!canWatch}>
            {(!canWatch && (
              <SideCta>
                <BigButton
                  width={'214px'}
                  style={{position: 'sticky', top: 100, marginRight: '1rem'}}
                  color={'#ffffff'}
                  hoverRule={highlightButton ? 'background-color: #564c78;' : 'color: var(--primary); border: 1px solid var(--primary);'}
                  border={highlightButton ? 'none' : '#ffffff'}
                  background={highlightButton ? 'var(--primary)' : 'transparent'}
                  onClick={() =>{
                    if (!data.purchased && (data.type as ProductType).label === 'course'){
                      navigate(`/buy/${data.id}`)
                      return
                    }
                    navigate(`/login?redirectTo=${encodeURIComponent(location.pathname)}`)
                  }}
                  label={
                    <>
                      {
                        getProductPrice(data, user)?.amount !== 0 ?
                          (
                            <div style={{display: 'flex', justifyContent: 'space-between', fontSize: '20px'}}>
                              <span>
                                   <span>{translation.common?.buttons.buy}</span>
                                  <span>
                                    {getProductPrice(data, user)?.amount}
                                    {getProductPrice(data, user)?.currencySymbol}
                                  </span>
                              </span>
                            </div>
                          )
                          :
                          <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                           <span>{translation.PAGES.login.login}</span>
                          </div>
                      }
                    </>
                  }
                />
              </SideCta>
            ))}
          </ButtonContainer>}
          {children}
        </InfoContainer>
      </Container>
    )
  )
}

export default InfoMasterclass

interface Props {
  openMenu?: () => void
  data: Product
  detail?: boolean
  isMenuOpen?: boolean
  purchased?: boolean
  courseType?: string
  jumboContainerHeight?: number
}

const Container = styled.div<{ isMobile: boolean }>`
  width: 100%;
  max-width: clamp(400px, 90%, var(--max-content-width));
  margin: ${(props) => (props.isMobile ? '0' : '1rem')} auto;
`

const InfoTextContainer = styled.div<{canWatch?: boolean}>`
  flex-basis: ${({canWatch})=> canWatch ? '100%' : '75%' };
`

const InfoUpContainer = styled.div`
    display:flex;
    justify-content:space-between;
`

const InfoContainer = styled.div<{ isMobile: boolean }>`
  display: flex;
  justify-content: space-between;
  height: fit-content;
  padding-bottom: 2rem;
`

const SideCta = styled.div`
  width: 100%;
  height: 100%;
  position:relative;
`

const ButtonContainer = styled.div<{mustVisible: boolean}>`
  ${({mustVisible})=> mustVisible ? 'display: block' : 'display: none;' }
`

const Info = styled.div``
const InfoR = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  align-self: start;
`

const FastInfo = styled.div`
  display: flex;
  align-items: center;
  margin-right: 20px;
`
const Description = styled.div`
  width: 100%;
  max-width: 80vw;
  padding: 4rem 0;
  font-size: 1.56rem;
  font-weight: 300;
  line-height: 40px;
`
